// TODO - Update the assetTags and windowsMachineName data
export const overview_actions = {
  carts: [
    {
      id: 2017,
      name: 'A5 West',
      locationId: 5,
      locationName: 'Manhattan - Building A',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '7164',
          capacity: 200,
          wastedCount: 1,
          percentFull: 65,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '3273',
          capacity: 200,
          wastedCount: 5,
          percentFull: 100,
        },
      ],
      collectionBox: {
        wastedCount: 3,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 26,
      },
      cartMode: 'Wasting',
      inUse: false,
      windowsMachineName: 'IQ-LAP47',
      assetTag: 'MS867531',
    },
    {
      id: 7703,
      name: '2B South',
      locationId: 6,
      locationName: 'Manhattan - Building B',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '2152',
          capacity: 200,
          wastedCount: 0,
          percentFull: 96,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '4409',
          capacity: 200,
          wastedCount: 1,
          percentFull: 26,
        },
      ],
      collectionBox: {
        wastedCount: 4,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 100,
      },
      cartMode: 'Wasting',
      inUse: false,
      windowsMachineName: 'IQ-LAP48',
      assetTag: 'MS867532',
    },
    {
      id: 1140,
      name: '3N North',
      locationId: 7,
      locationName: 'Manhattan - Building C',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '2541',
          capacity: 200,
          wastedCount: 1,
          percentFull: 90,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '3382',
          capacity: 200,
          wastedCount: 4,
          percentFull: 30,
        },
      ],
      collectionBox: {
        wastedCount: 4,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 73,
      },
      cartMode: 'Wasting',
      inUse: false,
      readyForReview: true,
      windowsMachineName: 'IQ-LAP49',
      assetTag: 'MS867533',
    },
    {
      id: 8618,
      name: 'ER-8',
      locationId: 8,
      locationName: 'Brooklyn - Building A',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '6031',
          capacity: 200,
          wastedCount: 4,
          percentFull: 2,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '4020',
          capacity: 200,
          wastedCount: 5,
          percentFull: 75,
        },
      ],
      collectionBox: {
        wastedCount: 4,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 78,
      },
      cartMode: 'Wasting',
      inUse: false,
      error: {
        description: 'Lockbox open',
        detectedAt: '2023-10-01T12:00:00Z',
        priority: 'Low',
        attendedBy: 'John Doe',
        startAttendedAt: '2023-10-01T12:00:00Z',
        errorFinishAttendedAt: '2023-10-01T12:00:00Z',
      },
      windowsMachineName: 'IQ-LAP50',
      assetTag: 'MS867534',
    },
    {
      id: 2876,
      name: 'OR-4',
      locationId: 9,
      locationName: 'Brooklyn - Building B',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '8412',
          capacity: 200,
          wastedCount: 4,
          percentFull: 16,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '7691',
          capacity: 200,
          wastedCount: 3,
          percentFull: 33,
        },
      ],
      collectionBox: {
        wastedCount: 5,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 58,
      },
      cartMode: 'Wasting',
      inUse: false,
      windowsMachineName: 'IQ-LAP51',
      assetTag: 'MS867535',
    },
    {
      id: 2162,
      name: 'ER-2',
      locationId: 10,
      locationName: 'Brooklyn - Building C',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '9236',
          capacity: 200,
          wastedCount: 4,
          percentFull: 93,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '2492',
          capacity: 200,
          wastedCount: 4,
          percentFull: 86,
        },
      ],
      collectionBox: {
        wastedCount: 5,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 79,
      },
      cartMode: 'Wasting',
      inUse: false,
      readyForReview: true,
      windowsMachineName: 'IQ-LAP452',
      assetTag: 'MS867536',
    },
    {
      id: 1013,
      name: '2A South',
      locationId: 11,
      locationName: 'Bronx - Building A',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '6972',
          capacity: 200,
          wastedCount: 4,
          percentFull: 27,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '9459',
          capacity: 200,
          wastedCount: 1,
          percentFull: 100,
        },
      ],
      collectionBox: {
        wastedCount: 5,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 70,
      },
      cartMode: 'Wasting',
      inUse: false,
      error: {
        description: 'Lockbox open',
        detectedAt: '2023-10-01T12:00:00Z',
        priority: 'High',
        attendedBy: 'Richard M',
        errorStartAttendedAt: '2023-10-01T12:00:00Z',
      },
      windowsMachineName: 'IQ-LAP53',
      assetTag: 'MS867537',
    },
    {
      id: 4856,
      name: '5B South',
      locationId: 12,
      locationName: 'Bronx - Building B',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '9750',
          capacity: 200,
          wastedCount: 0,
          percentFull: 65,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '2223',
          capacity: 200,
          wastedCount: 5,
          percentFull: 21,
        },
      ],
      collectionBox: {
        wastedCount: 2,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 100,
      },
      cartMode: 'Wasting',
      inUse: false,
      windowsMachineName: 'IQ-LAP54',
      assetTag: 'MS867538',
    },
    {
      id: 2898,
      name: '3C North',
      locationId: 13,
      locationName: 'Bronx - Building C',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '3140',
          capacity: 200,
          wastedCount: 3,
          percentFull: 84,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '6906',
          capacity: 200,
          wastedCount: 1,
          percentFull: 24,
        },
      ],
      collectionBox: {
        wastedCount: 4,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 100,
      },
      cartMode: 'Wasting',
      inUse: false,
      windowsMachineName: 'IQ-LAP55',
      assetTag: 'MS867539',
    },
  ],
};
